import { useState, useEffect } from "react";
import Select from "../../../components/select";
import arrow from "../../../assets/svg-icons/blueArrow.svg";
import close from "../../../assets/svg-icons/closeBrand.svg";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNetworkList, useSubnetList } from "../layout/resuableEffect";
import { FormatDate, formatMonthYear } from "../../../hooks/constants";
import { useFormik } from "formik";
import * as Yup from "yup";
import Input from "../../../components/input";
import Button from "../../../components/button";
import TextArea from "../../../components/textArea";

import { createProjectNetworks, deleteProjectNetwork, projectNetworkList, updateProjectNetwork } from "../../../hooks/local/userReducer";
import Modal from "../../../components/modal";
import usePartnerNavigation from "../../../hooks/usePartnerNavigation";




const Networks = () => {


  document.title = "Private Networks - Cloudvantage";

  const dispatch = useDispatch();
  const { navigate, generatePartnerUrl } = usePartnerNavigation();


  const [searchText, setSearchText] = useState("");
  const projectId = useSelector((state) => state.user.selectedProject).id;

  const currency = useSelector((state) => state.user.currency);
  const [currencyPTag, setCurrencyPTag] = useState("");
  const [networkModal, setNetworkModal] = useState(false);
  const [manageNetworkModal, setManageNetworkModal] = useState(false);
  const [editNetworkModal, setEditNetworkModal] = useState(false); 
  const [networkDetailsModal, setNetworkDetailsModal] = useState(false); 
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [deleteNetworkModal, setDeleteNetworkModal] = useState(false); 

  const showManageNetworkModal = (key, data) => {
    setManageNetworkModal(key);
    const networkDetails = { networkId: data.id, networkName: data.name };
    sessionStorage.setItem("selectedNetwork", JSON.stringify(networkDetails));
  };
  
 const closeManageNetworkModal = () => {
    setManageNetworkModal(false);
 };


  const toggleNetworkModal = () => {
    setNetworkModal(!networkModal);
  };

  const toggleEditNetworkModal = (network) => {
    setSelectedNetwork(network);
    setEditNetworkModal(!editNetworkModal);
  };
  

  const showNetworkDetailsModal = (network) => {
    setSelectedNetwork(network);
    setNetworkDetailsModal(true);
  };

  const closeNetworkDetailsModal = () => {
    setNetworkDetailsModal(false);
    setSelectedNetwork(null);
  };


  useEffect(() => {
    if (currency === "NGN") {
      setCurrencyPTag("₦");
    }
    if (currency === "USD") {
      setCurrencyPTag("$");
    }
  }, [currency]);



  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    setCurrentPage(1);
  };

  const options = [
    { value: "all-networks", label: "All networks" },
    { value: "name", label: "Network Name" },
    { value: "status", label: "Status", },
  ];

    const networkList = useNetworkList(projectId);
    

    const networkListMap = Array.isArray(networkList)
      ? networkList.map((network) => ({
          name: network.name && network.name.trim() !== "" ? network.name : "Default Network",
          subnets:
            network.subnets && network.subnets.length > 0
              ? network.subnets
                  .map((subnet) => `${subnet.name}: ${subnet.cidr}`)
                  .join(", ") 
              : "N/A",
          shared: network.shared ? "Yes" : "No",
          external: network["router:external"] ? "Yes" : "No",
          adminState: network.admin_state_up ? "UP" : "DOWN",
          id: network.id,
          description: network?.description,
          zones:
          network.availability_zones && network.availability_zones.length > 0
            ? (network.availability_zones[0] ?? "N/A")
            : "N/A",
          status: network.status,
          createdAt: FormatDate(network.created_at),
        }))
      : [];


      const networkDetails = selectedNetwork
      ? [
          {
            title: "Name",
            value: selectedNetwork?.name || "N/A",
          },
          {
            title: "Network ID",
            value: selectedNetwork?.id || "N/A",
          },
          {
            title: "Project ID",
            value: selectedNetwork?.project_id || "N/A",
          },
          {
            title: "Status",
            value: selectedNetwork?.status || "N/A",
          },
          {
            title: "Admin State",
            value: selectedNetwork?.admin_state_up ? "UP" : "DOWN" || "N/A",
          },
          {
            title: "Shared",
            value: selectedNetwork?.shared ? "Yes" : "No" || "N/A",
          },
          {
            title: "External Network",
            value: selectedNetwork ? (selectedNetwork["router:external"] ? "Yes" : "No") : "N/A",
          },
          {
            title: "MTU",
            value: selectedNetwork?.mtu || "N/A",
          },
        ]
      : [];





  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 5;

  const filteredData = networkListMap?.filter((row) =>
    row?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
    row?.status?.toLowerCase().includes(searchText.toLowerCase()),

  );

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = filteredData.slice(
    indexOfFirstEntry,
    indexOfLastEntry,
  );
  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };


  const createNetwork = useFormik({
    initialValues: {
      networkName: "",
      description: "",
    },
    validationSchema: Yup.object({
      networkName: Yup.string().required("Name is required"),
    }),
    onSubmit: async (values) => {
      const { networkName, description } = values;
      const networkData = {
        name: networkName,
        projectId
      };
      if (description?.trim()) {
        networkData.description = description;
      }

      const { payload } = await dispatch(createProjectNetworks(networkData));
      if (payload.statuscode === "00") {
        await dispatch(projectNetworkList(projectId));
        window.location.reload();
      }
    },
  });

  const editNetwork = useFormik({

    initialValues: {
      networkName: selectedNetwork?.name || "",
      description: selectedNetwork?.description || "",
    },
    
    enableReinitialize: true, 
    validationSchema: Yup.object({
      networkName: Yup.string().required("Name is required"),
    }),

    onSubmit: async (values) => {
      const { networkName, description } = values;

      const networkData = {
        networkId: selectedNetwork.id,
        name: networkName,
        projectId,
      };
      if (description?.trim()) {
        networkData.description = description;
      }

      const { payload } = await dispatch(updateProjectNetwork(networkData)); 
      if (payload.statuscode === "00") {
        await dispatch(projectNetworkList(projectId));
        setEditNetworkModal(false);
        window.location.reload();
      }
    },
  });

  const handleServerAction = async (action, networkId) => {

    const { payload } = await dispatch(action({ projectId, networkId }));

    if (payload.statuscode === "00") {
      window.location.reload();
    }
  };


const deleteNetwork = (networkId) =>
  handleServerAction(deleteProjectNetwork, networkId);


const handleRedirectToDetails = (index, row) => {
  showManageNetworkModal(index, row);
  navigate("/networks/network-details");
}

const subnetList = useSubnetList(projectId, "");

  

  return (
    <div className="min-h-screen px-4 md:px-10 pt-6 pb-10 dark:text-white">
      <p className="crimson-font text-xl font-medium text-primaryBlue">
        Manage your Private Networks
      </p>


      {networkListMap?.length > 0 ?
        <div>

          <div className="w-full flex justify-between items-center gap-4 lg:flex-row flex-col mb-10">
            <div className="w-full md:w-[initial] grid grid-cols-1 md:grid-cols-12 gap-4 items-end my-10">
                <div className="md:col-span-3">
                    <Select label="Filter networks" name="networks" options={options} />
                </div>
                <div className="md:col-span-4">
                <input
                    type="search"
                    name=""
                    value={searchText}
                    onChange={handleSearchChange}
                    placeholder="Search for network..."
                    className="bg-white text-black w-full p-4 text-sm rounded-md border border-[#c4c4c460] active:outline-0 focus:outline-0 placeholder:opacity-70 placeholder:text-xs dark:bg-slate-800 dark:text-white"
                />
                </div>
            </div>

            <div
                className="px-4 py-3 text-xs border-[1.5px] border-primaryBlue rounded-md text-primaryBlue cursor-pointer w-fit"
                onClick={toggleNetworkModal}
            >
                Create network
            </div>

          </div>  

          <div className="overflow-x-auto rounded-md border dark:border-[#c4c4c432]">
            <table className="w-full text-sm text-left overflow-hidden">
              <thead className="bg-white dark:bg-slate-800 px-3 md:px-4 border text-gray-400 dark:border-[#c4c4c432] border-b text-sm font-semibold">
                <tr>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap w-5">
                        #
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap max-w-52">
                        Network name
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                        Subnets Associated
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                        Shared
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                        External
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                        Status
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                        Admin State
                    </th>
                    {/* <th scope="col" className="px-6 py-4 whitespace-nowrap">
                        Availability Zones
                    </th> */}
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                        Actions
                    </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-slate-800 px-3 md:px-4 border rounded-b-md dark:border-[#c4c4c432] border-t-2 text-sm">
                {currentEntries.map((row, index) => (
                  <tr
                    key={index}
                    className="dark:hover:bg-[#ffffff05] hover:bg-brandBlue/25 whitespace-nowrap"
                  >
                    <td className="text-start py-4 px-6">{index + 1}.</td>
                    <td
                      className="text-start py-4 px-6 text-primaryBlue hover:underline cursor-pointer"
                      // onClick={() => showNetworkDetailsModal(networkList.find((n) => n.id === row.id))}
                      onClick={() => handleRedirectToDetails(index, row)}
                    >
                      {row.name}
                    </td>
                    <td className="text-start py-4 px-6">{row.subnets}</td>
                    <td className="text-start py-4 px-6">{row.shared}</td>
                    <td className="text-start py-4 px-6">{row.external}</td>
                    <td className="text-start py-4 px-6">{row.status}</td>
                    <td className="text-start py-4 px-6">{row.adminState}</td>
                    {/* <td className="text-start py-4 px-6">{row.zones}</td> */}
                    <td className="text-start py-4 px-6">
                        <button
                          className="text-white p-3 text-xs rounded bg-primaryBlue w-full md:w-fit"
                          onClick={() => showManageNetworkModal(index, row)}
                        >
                          Manage Network
                        </button>

                        {manageNetworkModal === index && (
                            <div className="w-full fixed h-screen bg-black/70 top-0 left-0 px-4 flex items-end md:items-center justify-center z-50">
                                <div className="bg-white dark:bg-[#141D26] rounded w-full md:w-[30%] dark:text-white max-h-[80%] mb-4 md:mb-0 overflow-auto">
                                <div className="flex justify-between items-center text-sm p-6 border-b dark:border-b-[#c4c4c432]">
                                    <div className="flex gap-2 items-center">
                                        <span className="dark:text-white">
                                            Manage "{row.name}"
                                        </span>
                                        </div>
                                        <img
                                            src={close}
                                            onClick={closeManageNetworkModal}
                                            className="h-5 cursor-pointer"
                                            alt=""
                                        />
                                    </div>
                                    <div className="p-4 grid gap-1">
                                        <Link
                                            to={generatePartnerUrl("/networks/network-details")}
                                            className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
                                        >
                                            <span>View Network Details</span>
                                            <span>
                                                <img src={arrow} alt="" className="" />
                                            </span>
                                        </Link>

                                        <div className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all cursor-pointer" onClick={() => toggleEditNetworkModal(row)}>
                                            <span>Edit network</span>
                                            <span>
                                                <img src={arrow} alt="" className="" />
                                            </span>
                                        </div>

                                        {row.subnets === "N/A" && (
                                            <Link
                                                to={generatePartnerUrl("/networks/create-subnet")}
                                                className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
                                            >
                                                <span>Create subnet</span>
                                                <span>
                                                    <img src={arrow} alt="" className="" />
                                                </span>
                                            </Link>
                                        )}

                                        <div
                                            className="flex justify-self-center text-red-500 rounded-md py-5 px-3 text-center cursor-pointer"
                                            onClick={() => {
                                                setDeleteNetworkModal(true);
                                            }}
                                        >
                                            <span className="hover:underline">
                                                Delete network
                                            </span>
                                        </div>
                                    </div>
                                    <Modal
                                        title={"Delete Network"}
                                        isVisible={deleteNetworkModal}
                                        onClose={() => setDeleteNetworkModal(false)}
                                    >
                                        <div className="text-sm text-center pt-6 text-wrap">
                                            Are you sure you want to delete{" "}
                                            <span className="underline">{row.name}</span> .
                                            This action cannot be undone.
                                        </div>
                                        <div className="grid gap-4 justify-center py-6">
                                            <button
                                                className="bg-red-500 text-white text-xs px-6 py-4 rounded-sm w-fit"
                                                onClick={() => deleteNetwork(row.id)}

                                            >
                                                Yes, delete {row.name}
                                            </button>
                                            <button
                                                className="text-[#1DA1F2] text-sm px-6 py-2 hover:underline"
                                                onClick={() => setDeleteNetworkModal(false)}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </Modal>
                                </div>
                            </div>
                        )}
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="grid justify-center gap-4 md:flex md:justify-between items-center mt-4">
            <p className="text-gray-400 text-sm">
              Showing{" "}
              <span className="font-medium text-black dark:text-white">
                {indexOfFirstEntry + 1}
              </span>{" "}
              to{" "}
              <span className="font-medium text-black dark:text-white">
                {Math.min(indexOfLastEntry, networkListMap?.length)}
              </span>{" "}
              of{" "}
              <span className="font-medium text-black dark:text-white">
                {networkListMap?.length}
              </span>{" "}
              results
            </p>
            <div className=" flex gap-3">
              <button
                className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${currentPage === 1 ? "opacity-50" : "opacity-100"}`}
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <button
                className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${currentPage === totalPages ? "opacity-50" : "opacity-100"}`}
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>

        :

        <>
          <div className="md:px-52 text-center grid text-gray-500 mt-32">
            <div>It looks like you don't have a networks yet. Once you create a network, your network details will appear here.</div>
            <div className="border border-[#c4c4c450] dark:border-[#c4c4c416] rounded-md p-3 flex items-center justify-self-center mt-8 w-fit text-xs cursor-pointer" onClick={toggleNetworkModal}>
              <span>Create Network</span>
              <span className="ps-2">
                <img src={arrow} alt="" />
              </span>
            </div>
          </div>
        
        </> 
      
      }


        {/* network modal */}
        {networkModal && (
            <div className="fixed top-0 h-screen w-full left-0 z-50 bg-black/60 flex items-center justify-center p-4">
                <div className="bg-white dark:bg-[#141D26] rounded-md p-4 md:p-10 w-full md:w-1/3 max-h-[80%] overflow-y-scroll">
                    <div className="flex items-center justify-between mb-4">
                        <p className="text-primaryBlue">Create a network</p>
                        <span onClick={toggleNetworkModal} className="cursor-pointer">
                            <img alt="" src={close} className="h-5" />
                        </span>
                    </div>
        
                    <form className="gap-y-6 grid" onSubmit={createNetwork.handleSubmit}>
                        <Input
                            label={"Network name"}
                            type={"text"}
                            name={"networkName"}
                            value={createNetwork.values.networkName}
                            onBlur={createNetwork.handleBlur}
                            onChange={createNetwork.handleChange}
                            onError={
                            createNetwork.errors.networkName &&
                            createNetwork.touched.networkName
                                ? createNetwork.errors.networkName
                                : null
                            }
                        />

                        <TextArea
                            label={"Description"}
                            type={"text"}
                            name={"description"}
                            value={createNetwork.values.description}
                            onBlur={createNetwork.handleBlur}
                            onChange={createNetwork.handleChange}
                            onError={
                                createNetwork.errors.description &&
                                createNetwork.touched.description
                                    ? createNetwork.errors.description
                                    : null
                                }
                        />


                        <div className="flex justify-between items-center gap-2">
                            <Button 
                                buttonText={"Create Network"} 
                                buttonRole={"submit"} 
                            />
                        </div>
        
                    </form>
                </div>
            </div>
        )}


    {/* Edit Network Modal */}
      {editNetworkModal && selectedNetwork && (
        <div className="fixed top-0 h-screen w-full left-0 z-50 bg-black/60 flex items-center justify-center p-4">
          <div className="bg-white dark:bg-[#141D26] rounded-md p-4 md:p-10 w-full md:w-1/3 max-h-[80%] overflow-y-scroll">
            <div className="flex items-center justify-between mb-4">
              <p className="text-primaryBlue">Edit Network "{selectedNetwork?.name}"</p>
              <span onClick={() => toggleEditNetworkModal(null)} className="cursor-pointer">
                <img alt="" src={close} className="h-5" />
              </span>
            </div>

            <form className="gap-y-6 grid" onSubmit={editNetwork.handleSubmit}>
              <Input
                label={"Network name"}
                type={"text"}
                name={"networkName"}
                value={editNetwork.values.networkName}
                onBlur={editNetwork.handleBlur}
                onChange={editNetwork.handleChange}
                onError={
                  editNetwork.errors.networkName && editNetwork.touched.networkName
                    ? editNetwork.errors.networkName
                    : null
                }
              />

              <TextArea
                label={"Description"}
                type={"text"}
                name={"description"}
                value={editNetwork.values.description}
                onBlur={editNetwork.handleBlur}
                onChange={editNetwork.handleChange}
                onError={
                  editNetwork.errors.description && editNetwork.touched.description
                    ? editNetwork.errors.description
                    : null
                }
              />

              <div className="flex justify-between items-center gap-2">
                <Button 
                    buttonText={"Update Network"} 
                    buttonRole={"submit"} 
                />
              </div>
            </form>
          </div>
        </div>
      )}

            {/* Network Details Modal */}
            {networkDetailsModal && selectedNetwork && (
        <div className="fixed w-full bg-black/60 top-0 left-0 z-50 h-screen">
          <div className="w-full flex h-full items-center justify-center p-4">
            <div className="bg-white dark:bg-[#141D26] dark:text-white w-full md:w-[80%] rounded h-full overflow-y-auto">
              <div className="px-6 md:px-10 py-6 border-b dark:border-b-[#c4c4c432] flex justify-between items-center">
                <span className="text-primaryBlue font-medium">Network Information:</span>
                <span onClick={closeNetworkDetailsModal} className="cursor-pointer">
                  <img src={close} alt="Close" className="h-5" />
                </span>
              </div>

              <div className="py-10 grid gap-6 px-6">
                <div className="w-full flex flex-col items-start gap-4">
                  <h4 className="w-full text-black dark:text-white text-lg mb-4 border-b border-gray-400 pb-2">
                    Network Details:
                  </h4>

                  <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
                    {networkDetails.map((detail, index) => (
                      <div key={index} className="w-full flex flex-col items-start">
                        <h4 className="text-black dark:text-white text-lg">{detail.title}:</h4>
                        <h4 className="text-gray-800 dark:text-gray-200 font-semibold text-xl">
                          {detail.title === "Status" ? (
                            detail.value === "ACTIVE" ? (
                              <div className="flex gap-1 items-center bg-emerald-500 text-white py-2 px-6 rounded-md">
                                <span>Active</span>
                              </div>
                            ) : (
                              <div className="flex gap-1 items-center bg-red-600 text-white py-2 px-6 rounded-md">
                                <span>{detail.value}</span>
                              </div>
                            )
                          ) : (
                            detail.value
                          )}
                        </h4>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      


    </div>
  );
};

export default Networks;

